export default __webpack_public_path__ + "static/media/vitalizingjolt.97a7c6d8.png";